module.exports = __webpack_public_path__ + "static/img/bg3.0218234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg3.png
// module id = VTmb
// module chunks = 0